var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card-content',[_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100"},[_c('label',[_vm._v("利用規約の確認")])]),_c('div',{staticClass:"md-layout-item md-size-30"},[_c('md-field',[(_vm.apply)?_c('label',[_vm._v("上記利用規約に同意します")]):_vm._e()])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }